<div class="map_trip_container map-border" (mouseenter)="boxHoverOn()" (mouseleave)="boxMouseOut()">
    <smart-icon class="map-expand" name="map-expand" size="32" (click)="changeBoxStatus()" *ngIf="!isBoxShow">
    </smart-icon>
    <smart-icon class="map-collapse" name="map-collapse" size="32" (click)="changeBoxStatus()" *ngIf="isBoxShow && isBoxHoverOn">
    </smart-icon>
    <div class="trip-all" [ngClass]="{'isBoxShow': isBoxShow}">
        <div class="trip-header">
            <smart-icon class="trip-type-drive IconSelected" name="direction-drive" (click)="onClickDriveMode()">
            </smart-icon>
            <smart-icon class="trip-type-transit IconUnselected" name="direction-transit" (click)="onClickTransitMode()">
            </smart-icon>
            <smart-icon class="trip-type-walk IconUnselected" name="direction-walk" (click)="onClickWalkMode()">
            </smart-icon>
            <smart-icon class="close" name="close" size="26" (click)="closeTripPanel()"></smart-icon>
        </div>
        <div class="trip-body">
            <div class=" tripAutoCompleteContainer">
                <tam-map-trip-autocomplete class="autocomplete" [config]="sourceConfig" (eventSubject$)="onClickShowNearby($event)">
                </tam-map-trip-autocomplete>
                <ng-template #tripAddStopContainer>
                </ng-template>
                <tam-map-trip-autocomplete class="autocomplete" [config]="destinationConfig" (eventSubject$)="onClickShowNearby($event)">
                </tam-map-trip-autocomplete>
                <ng-template #tripAutoCompleteContainer>
                </ng-template>
            </div>
        </div>
        <div class="add-destination">
            <div class="error" [hidden]="errorMessage.length===0">
                {{errorMessage}}
            </div>
            <div>
                <smart-icon class="direction-plus2" name="direction-plus2" (click)="onClickAddTripAutocompleteCtrol($event)" size="26"></smart-icon>
                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish get-direction" (click)="onClickGetDirection()">
                    Get Direction</button>
            </div>
        </div>

        <div class="router-detail" *ngIf="routeData">
            <span class="route-via" *ngIf="routeData.summary">via {{routeData.summary}}</span>
            <div class='router-content'>
                <div *ngFor="let item of routeData.legs;let i = index; trackBy:trackByFn" class="router-legs">
                    <span class="route-address">{{item['start_address']}}</span>
                    <span class='time'>{{item.duration.text}}
                        <label>({{item.distance.text}})</label></span>
                    <div class="router-step" [ngClass]="{'step-line-clamp': !item.showRouteDetail }">
                        <div *ngFor="let item of item.steps;trackBy:trackByFn">
                            <div class="route-html" [innerHTML]="item.instructions"></div>
                        </div>
                    </div>
                    <span class="expand-label-state" (click)="showOrHideNavigateAddres(item,i)">{{item.showRouteDetail ?
                        showDetail:hideDetail}}</span>
                    <span *ngIf="i===routeData.legs.length-1" class="route-address">{{item['end_address']}}</span>
                </div>
            </div>
        </div>
    </div>
</div>